module.exports = __webpack_public_path__ + "static/media/exclamationError.71447c88.svg";